import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { assetsPricing, pbPreferredPricing, } from '../../../../../constants/PricingBenefits';
import { HowItWorksModal, VideoModal } from './components/Modals';
import { Img } from './components/Shared';
var constants = pbPreferredPricing.PrefPricingBanner;
var UnqualifiedDesktop = function () {
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-12 sui-bg-inactive", "data-testid": "UnqualifiedDesktop" },
        React.createElement("div", { className: "sui-col-span-7 xl:sui-col-span-6 sui-p-4 sui-flex" },
            React.createElement("div", { className: "sui-pt-3 sui-pr-4", "data-testid": "UnqualifiedDesktop__Logo" },
                React.createElement(Img, { src: assetsPricing.dollarLogo })),
            React.createElement("div", { 
                /* eslint-disable-next-line tailwindcss/no-arbitrary-value */
                className: "sui-max-w-[370px]", "data-testid": "UnqualifiedDesktop__Content" },
                React.createElement("div", { className: "lg:sui-hidden" },
                    React.createElement("p", { className: "sui-font-bold sui-text-3xl sui-pt-3" }, constants.unqualified.title),
                    React.createElement("p", { className: "sui-text-base sui-pt-3 sui-pb-3 sui-pr-7" }, constants.unqualified.content)),
                React.createElement("div", { className: "sui-hidden lg:sui-block" },
                    React.createElement("p", { className: "sui-font-bold sui-text-5xl sui-pt-3" }, constants.unqualified.title),
                    React.createElement("p", { className: "sui-text-lg sui-pt-3 sui-pb-3 sui-pr-7" }, constants.unqualified.content)))),
        React.createElement("div", { className: "xl:sui-hidden sui-col-span-5 xl:sui-col-span-6 sui-flex sui-flex-col sui-justify-center sui-pr-3", "data-testid": "UnqualifiedDesktop__Video" },
            React.createElement(VideoModal, { rounded: true })),
        React.createElement("div", { className: "sui-hidden xl:sui-flex sui-col-span-5 xl:sui-col-span-6", "data-testid": "UnqualifiedDesktop__Video" },
            React.createElement(VideoModal, null))));
};
var UnqualifiedMobile = function () {
    var Title = function () { return (React.createElement("p", { className: "sui-font-bold sui-text-lg", "data-testid": "UnqualifiedMobile__Title", style: { maxWidth: '270px' } }, constants.unqualified.title)); };
    var Content = function () { return (React.createElement("p", { className: "sui-py-4 sui-text-base", "data-testid": "UnqualifiedMobile__Content" }, constants.unqualified.content)); };
    var Video = function () { return (React.createElement("p", { "data-testid": "UnqualifiedMobile__Video" },
        React.createElement(VideoModal, { isMobile: true, rounded: true }))); };
    return (React.createElement("div", { "data-testid": "UnqualifiedMobile" },
        React.createElement(Title, null),
        React.createElement(Content, null),
        React.createElement(Video, null)));
};
var TierQualifiedDesktop = function () {
    return (React.createElement("div", { "data-testid": "TierQualifiedDesktop", className: "sui-flex sui-bg-inactive sui-p-2" },
        React.createElement("div", { className: "sui-p-6", "data-testid": "TierQualifiedDesktop__Logo" },
            React.createElement(Img, { src: assetsPricing.dollarLogo })),
        React.createElement("div", { className: "sui-p-6 sui-pl-0", "data-testid": "TierQualifiedDesktop__Content" },
            React.createElement("div", { className: "lg:sui-hidden" },
                React.createElement("p", { className: "sui-text-3xl sui-pb-2 sui-font-bold" }, constants.qualified.titleDesktop.line1),
                React.createElement("p", { className: "sui-text-lg sui-pb-5" }, constants.qualified.titleDesktop.line2)),
            React.createElement("div", { className: "sui-hidden lg:sui-block" },
                React.createElement("p", { className: "sui-text-5xl sui-pb-2 sui-font-bold" }, constants.qualified.titleDesktop.line1),
                React.createElement("p", { className: "sui-text-3xl sui-pb-5 sui-font-bold" }, constants.qualified.titleDesktop.line2)),
            React.createElement("div", { className: "sui-text-xl sui-font-bold" },
                React.createElement(HowItWorksModal, null)))));
};
var TierQualifiedMobile = function () {
    var Title = function () { return (React.createElement("div", { className: "sui-flex sui-mb-2", "data-testid": "TierQualifiedMobile__Title" },
        React.createElement("div", { className: "sui-pr-4" },
            React.createElement(Img, { src: assetsPricing.dollarLogo, width: "56", height: "56" })),
        React.createElement("div", null,
            React.createElement("p", { className: "sui-text-lg sui-font-bold" }, constants.qualified.titleMobile.line1),
            React.createElement(Typography, { variant: "h2", weight: "display" }, constants.qualified.titleMobile.line2)))); };
    return (React.createElement("div", { "data-testid": "TierQualifiedMobile" },
        React.createElement(Title, null),
        React.createElement(HowItWorksModal, { isMobile: true })));
};
var RenderUnqualified = function (_a) {
    var isMobile = _a.isMobile;
    return isMobile ? React.createElement(UnqualifiedMobile, null) : React.createElement(UnqualifiedDesktop, null);
};
var RenderTierQualified = function (_a) {
    var isMobile = _a.isMobile;
    return isMobile ? React.createElement(TierQualifiedMobile, null) : React.createElement(TierQualifiedDesktop, null);
};
export var PrefPricingBanner = function (props) {
    var isMobile = props.isMobile, isQualified = props.isQualified;
    var FinalRender = function () {
        return isQualified ? (React.createElement(RenderTierQualified, { isMobile: isMobile })) : (React.createElement(RenderUnqualified, { isMobile: isMobile }));
    };
    return (React.createElement("div", { className: isMobile ? '' : 'sui-pt-3' },
        React.createElement(FinalRender, null)));
};
